// removed by extract-text-webpack-plugin
module.exports = {"fixedWidth":"mantenedor-correos__fixedWidth___Z8_Pv"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/mantenedorCorreos/mantenedor-correos.css
// module id = 1082
// module chunks = 0